module.exports = __webpack_public_path__ + "static/media/monthly student attendance.63f2799e.svg";